
import { Component, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { HttpClient, HttpErrorResponse, HttpEventType  } from '@angular/common/http';
import { catchError } from 'rxjs/operators'

import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faFileImage, faSync } from '@fortawesome/free-solid-svg-icons';

import { Subscription, throwError} from 'rxjs';
import { LogoService } from '../../services/logo.service';
import { LogoManagerComponent } from '../../logo-manager/logo-manager.component';
import { ImportDialogComponent } from '../../architecture/import-dialog/import-dialog.component';

@Component({
  selector: 'app-logo-admin',
  templateUrl: './logo-admin.component.html',
  styleUrls: ['./logo-admin.component.scss']
})
export class LogoAdminComponent implements OnInit {

  private logosData$: Subscription;
  logosData:any;
  isLoading = false;
  searchLogos = "";

  constructor(
    private http: HttpClient,
    public logoService: LogoService,
    library: FaIconLibrary,
    public dialog: MatDialog,
  ) { 
    library.addIcons(faFileImage,faSync);
  }

  ngOnInit(): void {

        // wire up the logos
        this.logosData$ = this.logoService.logos$.subscribe(
          (responsedata: any) => {
            if(responsedata!=null){                  
              if(responsedata.loading){
                this.isLoading = true;
              } else {
                this.isLoading = false;
                this.logosData = responsedata["data"];                 
              }          
            }
          }
        )
    
        this.logoService.loadLogos();
  }


  getLogosList(){
    
    if(this.searchLogos.trim()=="") return this.logosData  
    return this.logosData.filter(x => (
      x.file.toLowerCase().includes(this.searchLogos.trim().toLowerCase())
    || x.file.toLowerCase().includes(this.searchLogos.trim().toLowerCase())
    || x.company.toLowerCase().includes(this.searchLogos.trim().toLowerCase())
    )
    )
    
  } 

  openLogo(id){
    
    let data = {       
      showEditable: true,
      account: 1,
      logoid:id
    }
    
    let dialogRef = this.dialog.open(LogoManagerComponent, {
      height: '600px',
      width: '700px',
      data: data
    });

    

    dialogRef.afterClosed().subscribe(result => {

    })  
  }

  syncWithAIC(){

    const importDialogRef = this.dialog.open(ImportDialogComponent, {
      width: '350px',
      height: '300px',
      data: {title:"Import", text: "Importing Logos from AIC ...", loading:true}
    });

    const formData = new FormData();
    this.http.post('/api/logos/getLogosFromAIC', formData, {reportProgress: true, observe: 'events'})
      .pipe(catchError(err => {        

        if(err["error"]["errors"]){
          importDialogRef.componentInstance.data = {title:"Import", text: "Problem importing logos", loading:false};
          return throwError(err);  

        } else if (err.error["message"]){
          importDialogRef.componentInstance.data = {title:"Import", text: "Problem importing logos:<br>" + err.error["message"].replace(/\|/g,"</br>"), loading:false};
          return throwError(err);  
        } else {
          importDialogRef.componentInstance.data = {title:"Import", text: "Problem importing logos", loading:false};
          return throwError(err);  
        }

      })
        
      )
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress){
         //  this.progress = Math.round(100 * event.loaded / event.total);
        }
        else if (event.type === HttpEventType.Response) {
          importDialogRef.componentInstance.data = {title:"Import from AIC", text: event.body["message"].replace(/\|/g,"</br>"), loading:false};
          this.logoService.loadLogos();
              
        }
      })    

  }
  

}
